function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { ContextTracker, ExternalTokenizer, Parser, NodeProp } from 'lezer'; // This file was generated by lezer-generator. You probably shouldn't edit it.

var StartTag = 1,
    StartCloseTag = 2,
    MismatchedStartCloseTag = 3,
    missingCloseTag = 34,
    IncompleteCloseTag = 4,
    SelfCloseEndTag = 5,
    commentContent = 35,
    Element = 11,
    OpenTag = 12,
    RawText = 26,
    Dialect_noMatch = 0;
/* Hand-written tokenizers for HTML. */

var selfClosers = {
  area: true,
  base: true,
  br: true,
  col: true,
  command: true,
  embed: true,
  frame: true,
  hr: true,
  img: true,
  input: true,
  keygen: true,
  link: true,
  meta: true,
  param: true,
  source: true,
  track: true,
  wbr: true,
  menuitem: true
};
var implicitlyClosed = {
  dd: true,
  li: true,
  optgroup: true,
  option: true,
  p: true,
  rp: true,
  rt: true,
  tbody: true,
  td: true,
  tfoot: true,
  th: true,
  tr: true
};
var closeOnOpen = {
  dd: {
    dd: true,
    dt: true
  },
  dt: {
    dd: true,
    dt: true
  },
  li: {
    li: true
  },
  option: {
    option: true,
    optgroup: true
  },
  optgroup: {
    optgroup: true
  },
  p: {
    address: true,
    article: true,
    aside: true,
    blockquote: true,
    dir: true,
    div: true,
    dl: true,
    fieldset: true,
    footer: true,
    form: true,
    h1: true,
    h2: true,
    h3: true,
    h4: true,
    h5: true,
    h6: true,
    header: true,
    hgroup: true,
    hr: true,
    menu: true,
    nav: true,
    ol: true,
    p: true,
    pre: true,
    section: true,
    table: true,
    ul: true
  },
  rp: {
    rp: true,
    rt: true
  },
  rt: {
    rp: true,
    rt: true
  },
  tbody: {
    tbody: true,
    tfoot: true
  },
  td: {
    td: true,
    th: true
  },
  tfoot: {
    tbody: true
  },
  th: {
    td: true,
    th: true
  },
  thead: {
    tbody: true,
    tfoot: true
  },
  tr: {
    tr: true
  }
};

function nameChar(ch) {
  return ch == 45 || ch == 46 || ch == 58 || ch >= 65 && ch <= 90 || ch == 95 || ch >= 97 && ch <= 122 || ch >= 161;
}

function isSpace(ch) {
  return ch == 9 || ch == 10 || ch == 13 || ch == 32;
}

var cachedName = null,
    cachedInput = null,
    cachedPos = 0;

function tagNameAfter(input, pos) {
  if (cachedPos == pos && cachedInput == input) return cachedName;
  var next = input.get(pos);

  while (isSpace(next)) {
    next = input.get(++pos);
  }

  var start = pos;

  while (nameChar(next)) {
    next = input.get(++pos);
  } // Undefined to signal there's a <? or <!, null for just missing


  cachedInput = input;
  cachedPos = pos;
  return cachedName = pos > start ? input.read(start, pos).toLowerCase() : next == question || next == bang ? undefined : null;
}

var lessThan = 60,
    greaterThan = 62,
    slash = 47,
    question = 63,
    bang = 33;

function ElementContext(name, parent) {
  this.name = name;
  this.parent = parent;
  this.hash = parent ? parent.hash : 0;

  for (var i = 0; i < name.length; i++) {
    this.hash += (this.hash << 4) + name.charCodeAt(i) + (name.charCodeAt(i) << 8);
  }
}

var elementContext = new ContextTracker({
  start: null,
  shift: function shift(context, term, input, stack) {
    return term == StartTag ? new ElementContext(tagNameAfter(input, stack.pos) || "", context) : context;
  },
  reduce: function reduce(context, term) {
    return term == Element && context ? context.parent : context;
  },
  reuse: function reuse(context, node, input, stack) {
    var type = node.type.id;
    return type == StartTag || type == OpenTag ? new ElementContext(tagNameAfter(input, stack.pos - node.length + 1) || "", context) : context;
  },
  hash: function hash(context) {
    return context ? context.hash : 0;
  },
  strict: false
});
var tagStart = new ExternalTokenizer(function (input, token, stack) {
  var pos = token.start,
      first = input.get(pos),
      close; // End of file, close any open tags

  if (first < 0 && stack.context) token.accept(missingCloseTag, token.start);
  if (first != lessThan) return;
  pos++;
  if (close = input.get(pos) == slash) pos++;
  var name = tagNameAfter(input, pos);
  if (name === undefined) return;
  if (!name) return token.accept(close ? IncompleteCloseTag : StartTag, pos);
  var parent = stack.context ? stack.context.name : null;

  if (close) {
    if (name == parent) return token.accept(StartCloseTag, pos);
    if (parent && implicitlyClosed[parent]) return token.accept(missingCloseTag, token.start);
    if (stack.dialectEnabled(Dialect_noMatch)) return token.accept(StartCloseTag, pos);

    for (var cx = stack.context; cx; cx = cx.parent) {
      if (cx.name == name) return;
    }

    token.accept(MismatchedStartCloseTag, pos);
  } else {
    if (parent && closeOnOpen[parent] && closeOnOpen[parent][name]) token.accept(missingCloseTag, token.start);else token.accept(StartTag, pos);
  }
});
var selfClosed = new ExternalTokenizer(function (input, token, stack) {
  var next = input.get(token.start),
      end = token.start + 1;

  if (next == slash) {
    if (input.get(end) != greaterThan) return;
    end++;
  } else if (next != greaterThan) {
    return;
  }

  if (stack.context && selfClosers[stack.context.name]) token.accept(SelfCloseEndTag, end);
});
var commentContent$1 = new ExternalTokenizer(function (input, token) {
  var pos = token.start,
      endPos = 0;

  for (;;) {
    var next = input.get(pos);
    if (next < 0) break;
    pos++;

    if (next == "-->".charCodeAt(endPos)) {
      endPos++;

      if (endPos == 3) {
        pos -= 3;
        break;
      }
    } else {
      endPos = 0;
    }
  }

  if (pos > token.start) token.accept(commentContent, pos);
});
var openTag = /^<\/?\s*([\.\-\:\w\xa1-\uffff]+)/;

function tagName(tag) {
  var m = openTag.exec(tag);
  return m ? m[1].toLowerCase() : null;
}

function attributes(tag) {
  var open = openTag.exec(tag),
      attrs = {};

  if (open) {
    var attr = /\s*([\.\-\:\w\xa1-\uffff]+)\s*(?:=\s*(?:"([^"]*)"|'([^']*)'|([^\s=<>"'/]+)))?/g,
        m;
    attr.lastIndex = open.index + open[0].length;

    while (m = attr.exec(tag)) {
      attrs[m[1]] = m[4] || m[3] || m[2] || m[1];
    }
  }

  return attrs;
}

function skip(name) {
  return function (token) {
    return tagName(token) == name;
  };
} // tags: {
//   tag: string,
//   attrs?: ({[attr: string]: string}) => boolean,
//   parser: {startParse: (input: Input, startPos?: number, context?: ParseContext) => IncrementalParse}
// }[]


function resolveContent(tags) {
  var tagMap = null;

  var _iterator = _createForOfIteratorHelper(tags),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var tag = _step.value;
      if (!tagMap) tagMap = Object.create(null);
      (tagMap[tag.tag] || (tagMap[tag.tag] = [])).push({
        attrs: tag.attrs,
        value: {
          filterEnd: skip(tag.tag),
          startParse: tag.parser.startParse.bind(tag.parser)
        }
      });
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return function (input, stack) {
    var openTag = input.read(stack.ruleStart, stack.pos);
    var name = tagName(openTag),
        matches,
        attrs;
    if (!name) return null;

    if (tagMap && (matches = tagMap[name])) {
      var _iterator2 = _createForOfIteratorHelper(matches),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var match = _step2.value;
          if (!match.attrs || match.attrs(attrs || (attrs = attributes(openTag)))) return match.value;
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }

    if (name == "script" || name == "textarea" || name == "style") return {
      filterEnd: skip(name),
      wrapType: RawText
    };
    return null;
  };
}

var elementContent = resolveContent([]);

function configureNesting(tags) {
  return {
    elementContent: resolveContent(tags)
  };
} // This file was generated by lezer-generator. You probably shouldn't edit it.


var parser = Parser.deserialize({
  version: 13,
  states: "'OOVOXOOOwQ`O'#ChS!kOXO'#CgOOOP'#Cg'#CgO!uOdO'#CrO!}Q`O'#CtOOOP'#DS'#DSOOOP'#Cw'#CwQVOXOOO#SQrO,59SOOOP'#C{'#C{O#_OXO'#DXO#iOPO,59ROOOS'#C|'#C|O#qOdO,59^OOOP,59^,59^O#yQ`O,59`OOOP-E6u-E6uO$OQrO'#CjOOQQ'#Cx'#CxO$^QrO1G.nOOOP1G.n1G.nOOOP1G.w1G.wOOOP-E6y-E6yO$iQ`O'#CpOOOP1G.m1G.mOOOS-E6z-E6zOOOP1G.x1G.xOOOP1G.z1G.zO$nQ!bO,59UOOQQ-E6v-E6vOOOP7+$Y7+$YOOOP7+$c7+$cO$yQ`O,59[O%OO#tO'#CmO%^O&jO'#CmOOQQ1G.p1G.pOOOP1G.v1G.vOOOO'#Cy'#CyO%lO#tO,59XOOQQ,59X,59XOOOO'#Cz'#CzO%zO&jO,59XOOOO-E6w-E6wOOQQ1G.s1G.sOOOO-E6x-E6x",
  stateData: "&b~OuOS~OPPORTOSUOVUOWUOXUOYUOgUOiVO|SO~O]XO~OPPORTOSUOVUOWUOXUOYUOgUO|SO~OQ{Pr{P~P|Os]O}_O~O]`O~OTfO_bOceO~OQ{Xr{X~P|OQhOriO~Os]O}kO~OclO~O`mOT^X_^Xc^X~OTpO_bOcoO~O]qO~ObtOwrOysO~OcuO~OWvOXvOwxOxvO~OWyOXyOyxOzyO~OWvOXvOw|OxvO~OWyOXyOy|OzyO~OXWY|gi|~",
  goto: "#l|PPPPPPPPPPP}!TP!ZPP!_PP!b!e}P}PP!k!q!w!}#T#ZPPPPP#aPPPP#iXUOQWZXQOQWZTcXdRtmRi[XROQWZQWORaWQdXRndQwrR{wQzsR}zQZQRgZQ^SRj^SVOWTYQZR[Q",
  nodeNames: "⚠ StartTag StartCloseTag StartCloseTag IncompleteCloseTag SelfCloseEndTag Document Text EntityReference CharacterReference InvalidEntity Element OpenTag TagName Attribute AttributeName Is AttributeValue UnquotedAttributeValue EndTag CloseTag SelfClosingTag Comment ProcessingInst MismatchedCloseTag DoctypeDecl RawText",
  maxTerm: 45,
  context: elementContext,
  nodeProps: [[NodeProp.closedBy, -2, 1, 2, "EndTag SelfCloseEndTag", 12, "CloseTag"], [NodeProp.openedBy, 5, "StartTag", 19, "StartTag StartCloseTag", 20, "OpenTag"]],
  skippedNodes: [0, 26],
  repeatNodeCount: 6,
  tokenData: "!#b!aR!WOX$kXY)sYZ)sZ]$k]^)s^p$kpq)sqr$krs*zsv$kvw+dwx2yx}$k}!O3f!O!P$k!P!Q7_!Q![$k![!]8u!]!^$k!^!_>b!_!`!!p!`!a8T!a!c$k!c!}8u!}#R$k#R#S8u#S#T$k#T#o8u#o$f$k$f$g&R$g%W$k%W%o8u%o%p$k%p&a8u&a&b$k&b1p8u1p4U$k4U4d8u4d4e$k4e$IS8u$IS$I`$k$I`$Ib8u$Ib$Kh$k$Kh%#t8u%#t&/x$k&/x&Et8u&Et&FV$k&FV;'S8u;'S;:j<t;:j?&r$k?&r?Ah8u?Ah?BY$k?BY?Mn8u?Mn~$k!Z$vcVPbWx`zpOX$kXZ&RZ]$k]^&R^p$kpq&Rqr$krs&qsv$kvw)Rwx'rx!P$k!P!Q&R!Q!^$k!^!_(k!_!a&R!a$f$k$f$g&R$g~$k!R&[VVPx`zpOr&Rrs&qsv&Rwx'rx!^&R!^!_(k!_~&Rq&xTVPzpOv&qwx'Xx!^&q!^!_'g!_~&qP'^RVPOv'Xw!^'X!_~'Xp'lQzpOv'gx~'ga'yUVPx`Or'rrs'Xsv'rw!^'r!^!_(]!_~'r`(bRx`Or(]sv(]w~(]!Q(rTx`zpOr(krs'gsv(kwx(]x~(kW)WXbWOX)RZ])R^p)Rqr)Rsw)Rx!P)R!Q!^)R!a$f)R$g~)R!a*O^VPx`zpu^OX&RXY)sYZ)sZ]&R]^)s^p&Rpq)sqr&Rrs&qsv&Rwx'rx!^&R!^!_(k!_~&R!Z+TTwhVPzpOv&qwx'Xx!^&q!^!_'g!_~&q!Z+kbbWYPOX,sXZ.QZ],s]^.Q^p,sqr,srs.Qst/]tw,swx.Qx!P,s!P!Q.Q!Q!],s!]!^)R!^!a.Q!a$f,s$f$g.Q$g~,s!Z,xbbWOX,sXZ.QZ],s]^.Q^p,sqr,srs.Qst)Rtw,swx.Qx!P,s!P!Q.Q!Q!],s!]!^.i!^!a.Q!a$f,s$f$g.Q$g~,s!R.TTOp.Qqs.Qt!].Q!]!^.d!^~.Q!R.iOW!R!Z.pXbWW!ROX)RZ])R^p)Rqr)Rsw)Rx!P)R!Q!^)R!a$f)R$g~)R!Z/babWOX0gXZ1qZ]0g]^1q^p0gqr0grs1qsw0gwx1qx!P0g!P!Q1q!Q!]0g!]!^)R!^!a1q!a$f0g$f$g1q$g~0g!Z0labWOX0gXZ1qZ]0g]^1q^p0gqr0grs1qsw0gwx1qx!P0g!P!Q1q!Q!]0g!]!^2V!^!a1q!a$f0g$f$g1q$g~0g!R1tSOp1qq!]1q!]!^2Q!^~1q!R2VOX!R!Z2^XbWX!ROX)RZ])R^p)Rqr)Rsw)Rx!P)R!Q!^)R!a$f)R$g~)R!Z3SUyxVPx`Or'rrs'Xsv'rw!^'r!^!_(]!_~'r!]3qeVPbWx`zpOX$kXZ&RZ]$k]^&R^p$kpq&Rqr$krs&qsv$kvw)Rwx'rx}$k}!O5S!O!P$k!P!Q&R!Q!^$k!^!_(k!_!a&R!a$f$k$f$g&R$g~$k!]5_dVPbWx`zpOX$kXZ&RZ]$k]^&R^p$kpq&Rqr$krs&qsv$kvw)Rwx'rx!P$k!P!Q&R!Q!^$k!^!_(k!_!`&R!`!a6m!a$f$k$f$g&R$g~$k!T6xVVPx`zp}QOr&Rrs&qsv&Rwx'rx!^&R!^!_(k!_~&R!X7hXVPx`zpOr&Rrs&qsv&Rwx'rx!^&R!^!_(k!_!`&R!`!a8T!a~&R!X8`VcUVPx`zpOr&Rrs&qsv&Rwx'rx!^&R!^!_(k!_~&R!a9U!Y_S]QVPbWx`zpOX$kXZ&RZ]$k]^&R^p$kpq&Rqr$krs&qsv$kvw)Rwx'rx}$k}!O8u!O!P8u!P!Q&R!Q![8u![!]8u!]!^$k!^!_(k!_!a&R!a!c$k!c!}8u!}#R$k#R#S8u#S#T$k#T#o8u#o$f$k$f$g&R$g$}$k$}%O8u%O%W$k%W%o8u%o%p$k%p&a8u&a&b$k&b1p8u1p4U8u4U4d8u4d4e$k4e$IS8u$IS$I`$k$I`$Ib8u$Ib$Je$k$Je$Jg8u$Jg$Kh$k$Kh%#t8u%#t&/x$k&/x&Et8u&Et&FV$k&FV;'S8u;'S;:j<t;:j?&r$k?&r?Ah8u?Ah?BY$k?BY?Mn8u?Mn~$k!a=PeVPbWx`zpOX$kXZ&RZ]$k]^&R^p$kpq&Rqr$krs&qsv$kvw)Rwx'rx!P$k!P!Q&R!Q!^$k!^!_(k!_!a&R!a$f$k$f$g&R$g;=`$k;=`<%l8u<%l~$k!R>iWx`zpOq(kqr?Rrs'gsv(kwx(]x!a(k!a!bKj!b~(k!R?YZx`zpOr(krs'gsv(kwx(]x}(k}!O?{!O!f(k!f!gAR!g#W(k#W#XGz#X~(k!R@SVx`zpOr(krs'gsv(kwx(]x}(k}!O@i!O~(k!R@rTx`zp|POr(krs'gsv(kwx(]x~(k!RAYVx`zpOr(krs'gsv(kwx(]x!q(k!q!rAo!r~(k!RAvVx`zpOr(krs'gsv(kwx(]x!e(k!e!fB]!f~(k!RBdVx`zpOr(krs'gsv(kwx(]x!v(k!v!wBy!w~(k!RCQVx`zpOr(krs'gsv(kwx(]x!{(k!{!|Cg!|~(k!RCnVx`zpOr(krs'gsv(kwx(]x!r(k!r!sDT!s~(k!RD[Vx`zpOr(krs'gsv(kwx(]x!g(k!g!hDq!h~(k!RDxWx`zpOrDqrsEbsvDqvwEvwxFfx!`Dq!`!aGb!a~DqqEgTzpOvEbvxEvx!`Eb!`!aFX!a~EbPEyRO!`Ev!`!aFS!a~EvPFXOiPqF`QzpiPOv'gx~'gaFkVx`OrFfrsEvsvFfvwEvw!`Ff!`!aGQ!a~FfaGXRx`iPOr(]sv(]w~(]!RGkTx`zpiPOr(krs'gsv(kwx(]x~(k!RHRVx`zpOr(krs'gsv(kwx(]x#c(k#c#dHh#d~(k!RHoVx`zpOr(krs'gsv(kwx(]x#V(k#V#WIU#W~(k!RI]Vx`zpOr(krs'gsv(kwx(]x#h(k#h#iIr#i~(k!RIyVx`zpOr(krs'gsv(kwx(]x#m(k#m#nJ`#n~(k!RJgVx`zpOr(krs'gsv(kwx(]x#d(k#d#eJ|#e~(k!RKTVx`zpOr(krs'gsv(kwx(]x#X(k#X#YDq#Y~(k!RKqWx`zpOrKjrsLZsvKjvwLowxNPx!aKj!a!b! g!b~KjqL`TzpOvLZvxLox!aLZ!a!bM^!b~LZPLrRO!aLo!a!bL{!b~LoPMORO!`Lo!`!aMX!a~LoPM^OgPqMcTzpOvLZvxLox!`LZ!`!aMr!a~LZqMyQzpgPOv'gx~'gaNUVx`OrNPrsLosvNPvwLow!aNP!a!bNk!b~NPaNpVx`OrNPrsLosvNPvwLow!`NP!`!a! V!a~NPa! ^Rx`gPOr(]sv(]w~(]!R! nWx`zpOrKjrsLZsvKjvwLowxNPx!`Kj!`!a!!W!a~Kj!R!!aTx`zpgPOr(krs'gsv(kwx(]x~(k!V!!{V`SVPx`zpOr&Rrs&qsv&Rwx'rx!^&R!^!_(k!_~&R",
  tokenizers: [tagStart, selfClosed, commentContent$1, 0, 1, 2, 3, 4, 5],
  topRules: {
    "Document": [0, 6]
  },
  nested: [["elementContent", elementContent, "%S~RP!^!_U~XP!P!Q[~_dXY[YZ[]^[pq[![!]!m!c!}!m#R#S!m#T#o!m%W%o!m%p&a!m&b1p!m4U4d!m4e$IS!m$I`$Ib!m$Kh%#t!m&/x&Et!m&FV;'S!m;'S;:j$|?&r?Ah!m?BY?Mn!m~!pkXY$eYZ$e]^$epq$e}!O!m!O!P!m!Q![!m![!]!m!`!a$w!c!}!m#R#S!m#T#o!m$}%O!m%W%o!m%p&a!m&b1p!m1p4U!m4U4d!m4e$IS!m$I`$Ib!m$Je$Jg!m$Kh%#t!m&/x&Et!m&FV;'S!m;'S;:j$|?&r?Ah!m?BY?Mn!m~$hTXY$eYZ$e]^$epq$e!`!a$w~$|Oq~~%PP;=`<%l!m", 43]],
  dialects: {
    noMatch: 0
  },
  tokenPrec: 240
});
export { configureNesting, parser };